import React from 'react';
import { NavLink } from 'react-router-dom';

const NavLinkCustomV2 = ({route = '/', text}) => (
    <div>
        <NavLink
            className="nav-link" 
            href="#" 
            to={route}>
                {text}
        </NavLink>
    </div>
);

export default NavLinkCustomV2;
